import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CartItem {
  id: string;
  name: string;
  price: number;
  quantity: number;
  author?: string;
  cover?: string;
}

interface OrderState {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  deliveryMethod: "courier" | "nova-poshta";
  deliveryDate: string;
  deliveryInterval: "10-13" | "14-17" | "19-21" | "";
  address: string;
  paymentMethod: "card" | "after-delivery";
  items: CartItem[];
}

const initialState: OrderState = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  deliveryMethod: "nova-poshta",
  deliveryDate: "",
  deliveryInterval: "",
  address: "",
  paymentMethod: "card",
  items: [],
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrderField(
      state,
      action: PayloadAction<{ field: keyof OrderState; value: any }>
    ) {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },
    setOrderItems(state, action: PayloadAction<CartItem[]>) {
      state.items = action.payload;
    },
    resetOrder() {
      return initialState;
    },
  },
});

export const { setOrderField, setOrderItems, resetOrder } = orderSlice.actions;
export default orderSlice.reducer;
